export const FACE_RECON_TEST_COMPANY_KEYS = [
  '5d13e050-6d53-4bd5-8037-496fdffaef63',
  'ca426354-c14f-4b1e-8044-45dbf298e4e2',
  'bd804a32-d3c4-4a4b-986f-f365327bd475'
]
  .map((companyKey) => companyKey.trim().toLowerCase())
  .filter(Boolean)
